import {DetailedHTMLProps, forwardRef, TextareaHTMLAttributes} from "react";

export type InputProps = {
    id: string;
    name: string;
    label: string;
    className?:string;
} & DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>

const Input = forwardRef<HTMLTextAreaElement, InputProps>((props,ref) => {
    return (
        <textarea {...props} ref={ref} id={props.id} name={props.name} aria-label={props.label} placeholder={props.placeholder} className={`px-4 w-full py-3 bg-transparent shadow dark:border border-cardGray placeholder-cardGray dark:text-white dark:border-slate-600 rounded ${props.className}`}>{props.value}</textarea>
    )
})

export default Input;